/* eslint-disable */

import React, { Component } from 'react';
import { Menu, Checkbox } from 'semantic-ui-react';

const isIndeterminate = (selectedAds, campaignMonth) => {
  return (
    selectedAds.length !== 0 && campaignMonth.length !== selectedAds.length
  );
};

const PresentationTabs = ({
  data: { tabs, campaignMonth, showCheckboxes, checkedCampaigns, selectedAds },
  handleItemClick,
  handleCheckChange
}) => (
  <Menu attached="top" tabular>
    <Menu.Item
      name="showTraffic"
      active={tabs.activeItem === 'showTraffic'}
      onClick={handleItemClick}
      className="transition tab-ad"
      style={{
        display: campaignMonth.LINK_CLICKS.length > 0 ? 'block' : 'none'
      }}
    >
      {showCheckboxes ? (
        <Checkbox
          indeterminate={isIndeterminate(
            selectedAds.LINK_CLICKS,
            campaignMonth.LINK_CLICKS
          )}
          defaultChecked={checkedCampaigns['LINK_CLICKS']}
          checked={checkedCampaigns['LINK_CLICKS']}
          className="select-account"
          name="LINK_CLICKS"
          type="checkbox"
          onChange={handleCheckChange}
        />
      ) : null}
      Traffic Ads
    </Menu.Item>
    <Menu.Item
      name="showLeads"
      active={tabs.activeItem === 'showLeads'}
      className="transition tab-ad"
      onClick={handleItemClick}
      style={{
        display: campaignMonth.LEAD_GENERATION.length > 0 ? 'block' : 'none'
      }}
    >
      {showCheckboxes ? (
        <Checkbox
          indeterminate={isIndeterminate(
            selectedAds.LEAD_GENERATION,
            campaignMonth.LEAD_GENERATION
          )}
          defaultChecked={checkedCampaigns['LEAD_GENERATION']}
          checked={checkedCampaigns['LEAD_GENERATION']}
          className="select-account"
          name="LEAD_GENERATION"
          type="checkbox"
          onChange={handleCheckChange}
        />
      ) : null}
      Lead Ads
    </Menu.Item>
    <Menu.Item
      name="showVideos"
      className="transition tab-ad"
      active={tabs.activeItem === 'showVideos'}
      onClick={handleItemClick}
      style={{
        display: campaignMonth.VIDEO_VIEWS.length > 0 ? 'block' : 'none'
      }}
    >
      {showCheckboxes ? (
        <Checkbox
          indeterminate={isIndeterminate(
            selectedAds.VIDEO_VIEWS,
            campaignMonth.VIDEO_VIEWS
          )}
          defaultChecked={checkedCampaigns['VIDEO_VIEWS']}
          checked={checkedCampaigns['VIDEO_VIEWS']}
          className="select-account"
          name="VIDEO_VIEWS"
          type="checkbox"
          onChange={handleCheckChange}
        />
      ) : null}
      Video Ads
    </Menu.Item>
    <Menu.Item
      name="showDynamic"
      className="transition tab-ad"
      active={tabs.activeItem === 'showDynamic'}
      onClick={handleItemClick}
      style={{
        display:
          campaignMonth.PRODUCT_CATALOG_SALES.length > 0 ? 'block' : 'none'
      }}
    >
      {showCheckboxes ? (
        <Checkbox
          indeterminate={isIndeterminate(
            selectedAds.PRODUCT_CATALOG_SALES,
            campaignMonth.PRODUCT_CATALOG_SALES
          )}
          defaultChecked={checkedCampaigns['PRODUCT_CATALOG_SALES']}
          checked={checkedCampaigns['PRODUCT_CATALOG_SALES']}
          className="select-account"
          name="PRODUCT_CATALOG_SALES"
          type="checkbox"
          onChange={handleCheckChange}
        />
      ) : null}
      Dynamic Ads
    </Menu.Item>
    <Menu.Item
      name="showConversions"
      active={tabs.activeItem === 'showConversions'}
      onClick={handleItemClick}
      className="transition tab-ad"
      style={{
        display: campaignMonth.CONVERSIONS.length > 0 ? 'block' : 'none'
      }}
    >
      {showCheckboxes ? (
        <Checkbox
          indeterminate={isIndeterminate(
            selectedAds.CONVERSIONS,
            campaignMonth.CONVERSIONS
          )}
          defaultChecked={checkedCampaigns['CONVERSIONS']}
          checked={checkedCampaigns['CONVERSIONS']}
          className="select-account"
          name="CONVERSIONS"
          type="checkbox"
          onChange={handleCheckChange}
        />
      ) : null}
      Conversion Ads
    </Menu.Item>
    <Menu.Item
      name="showMessenger"
      active={tabs.activeItem === 'showMessenger'}
      onClick={handleItemClick}
      className="transition tab-ad"
      style={{
        display: campaignMonth.CONVERSIONS.length > 0 ? 'block' : 'none'
      }}
    >
      {showCheckboxes ? (
        <Checkbox
          indeterminate={isIndeterminate(
            selectedAds.MESSAGES,
            campaignMonth.MESSAGES
          )}
          defaultChecked={checkedCampaigns['CONVERSIONS']}
          checked={checkedCampaigns['MESSAGES']}
          className="select-account"
          name="MESSAGES"
          type="checkbox"
          onChange={handleCheckChange}
        />
      ) : null}
      Messenger Ads
    </Menu.Item>
  </Menu>
);
export default PresentationTabs;



// WEBPACK FOOTER //
// ./src/screens/Presentation/PresentationTabs.js